import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Tab } from '../../core/components/tabs/tab';
import { Tabs } from '../../core/components/tabs/tabs';
import { WikiStatusService } from '../../api/services/wiki-status.service';
import { SafeMarkdownPipe } from '../../shared/pipes/safe-markdown.pipe';
import { DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
	selector: 'lvr-status',
	imports: [Tab, Tabs, SafeMarkdownPipe, DatePipe, TranslocoModule],
	templateUrl: './status.html',
	styleUrl: './status.scss',
	encapsulation: ViewEncapsulation.None,
})
export class Status {
	public readonly statusResource = inject(WikiStatusService).statusRessource;
}
